/* eslint-disable no-nested-ternary */
import moment from "moment";
import React, { Fragment, useState } from "react";
import "../documentation.css";
import { formatTimestamp } from "../helpers";
import { DoneIcon, TodoIcon } from "../../assets/Icons";
import CandImage from "../Components/CandImage";
import Initials from "../Components/Initials";
import pusterlaDocsObj from "./regattaDocsObj";
import LoadingSpinner from "../../common/LoadingSpinner";
import MedicalIcon from "../../common/icons/MedicalIcon";

const RegattaDocumnents = ({
  candidates,
  getReadingListPdf,
  agreeToWork,
  downloadRef,
  images,
  passImage,
  handleOverlay,
  approverEmail
}) => {
  const [loadingTypeCode, setLoadingTypeCode] = useState("");
  const [display, setDisplay] = useState(false);
  const [loadingRtw, setLoading] = useState("");
  const [loadingEl, setLoadingEl] = useState("");
  /**
   * Make call to profile 5 to retrieve desired file for Regatta
   * @param {String} candidate
   * @param {String} typeCode
   * @param {String} filename
   * @param {String} contentType
   * @param {String} fileExt
   */
  const handleDownloadReadingList = (
    candidate,
    typeCode,
    filename,
    contentType,
    fileExt,
    additionalInfo
  ) => {
    setLoadingTypeCode(typeCode);
    setLoadingEl(additionalInfo);
    getReadingListPdf(
      candidate.candidateRef,
      candidate.firstName,
      candidate.lastName,
      typeCode,
      filename,
      contentType,
      fileExt,
      additionalInfo
    ).then(() => {
      setLoadingTypeCode("");
      setLoadingEl("");
    });
  };
  const [highlightBtn, setHighlightBtn] = useState("");
  const [selected, setSelected] = useState(null);
  const [agreedTo, setAgreedTo] = useState({});

  const handleAgreeToWork = (candidateRef, el) => {
    agreeToWork(candidateRef, el).then(() => {
      setLoading("");
      setAgreedTo({
        ...agreedTo,
        [el]: {
          approverEmail,
          acceptedDate: new Date(Date.now())
        }
      });
    });
  };

  const hasMedicalIssue = c => {
    let issue = false;

    if (
      c.documents &&
      c.documents.MedicalQuestionnaire &&
      c.nonReadingListDocs &&
      c.nonReadingListDocs.YREG
    ) {
      const medicalDoc = c.documents.MedicalQuestionnaire;
      const listOfTrueKeys = [
        "MedicalQuestionnaire14",
        "MedicalQuestionnaire16",
        "MedicalQuestionnaire18",
        "MedicalQuestionnaire20",
        "MedicalQuestionnaire22",
        "MedicalQuestionnaire24",
        "MedicalQuestionnaire30",
        "MedicalQuestionnaire36",
        "MedicalQuestionnaire38"
      ];

      const listOfFalseKeys = [
        "MedicalQuestionnaire26",
        "MedicalQuestionnaire28"
      ];

      const listOfNestedKeys = [
        "MedicalQuestionnaire32",
        "MedicalQuestionnaire33",
        "MedicalQuestionnaire34"
      ];

      const checkIfAny = obj =>
        Object.values(obj).some(value => value === true);

      Object.keys(medicalDoc).forEach(el => {
        if (listOfTrueKeys.includes(el) && medicalDoc[el]) {
          issue = true;
        }
        if (listOfFalseKeys.includes(el) && medicalDoc[el] !== true) {
          issue = true;
        }
        if (listOfNestedKeys.includes(el) && checkIfAny(medicalDoc[el])) {
          issue = true;
        }
      });
    }
    return issue;
  };

  const setHighligtning = key =>
    highlightBtn === key ? setHighlightBtn("") : setHighlightBtn(key);

  const ViewButton = ({ id, fn, num, disabled = false }) => (
    <div className="tw-flex tw-flex-col tw-items-center tw-content-center tw-w-1/2 tw-py-10">
      <button
        disabled={disabled}
        className={`${id === highlightBtn &&
          !disabled &&
          "tw-border-blue-400 tw-text-white tw-bg-blue-400 tw-border-2"} tw-bg-blue-200' tw-bg-blue-100 tw-p-2 lg:tw-w-1/2 tw-w-full tw-rounded-lg ${id !==
          highlightBtn &&
          !disabled &&
          "hover:tw-bg-blue-200 hover:tw-border-blue-500"} tw-border-blue-300 tw-border-2 tw-cursor-pointer`}
        onClick={fn}
      >
        <span className="md:tw-inline tw-hidden">View</span>
        <span className="md:tw-hidden tw-inline">{num}</span>
      </button>
    </div>
  );

  const DOCS = pusterlaDocsObj;

  const getDocCount = candidate => {
    const values = Object.values(DOCS);

    if (!values) return undefined;
    let readCount = 0;

    values.forEach(row => {
      const { id } = row;
      const read =
        candidate &&
        candidate.documents &&
        candidate.documents.readings &&
        candidate.documents.readings[id];
      if (read) readCount += 1;
    });

    const hasNonReadingDocs = candidate && candidate.nonReadingListDocs;

    const hasYREG = hasNonReadingDocs && candidate.nonReadingListDocs.YREG;

    const hasYRG4 = hasNonReadingDocs && candidate.nonReadingListDocs.YRG4;

    const hasYRG5 = hasNonReadingDocs && candidate.nonReadingListDocs.YRG5;

    const hasYRG6 = hasNonReadingDocs && candidate.nonReadingListDocs.YRG6;

    const hasYRG7 = hasNonReadingDocs && candidate.nonReadingListDocs.YRG7;

    const hasNET2 =
      candidate &&
      candidate.documents &&
      candidate.documents.readings &&
      candidate.documents.readings["net2_communication_brief_v3.pdf"];

    const hasMLSF =
      candidate &&
      candidate.documents &&
      candidate.documents.readings &&
      candidate.documents.readings["management_of_locker_sign_off.pdf"];

    if (hasYREG) readCount += 1;
    if (hasNET2) readCount += 1;
    if (hasMLSF) readCount += 1;
    if (hasYRG4) readCount += 1;
    if (hasYRG5) readCount += 1;
    if (hasYRG6) readCount += 1;
    if (hasYRG7) readCount += 1;
    return { readCount };
  };

  const Header = ({ title, countObj = { readCount: 0 } }) => (
    <div className="tw-w-full tw-flex md:tw-flex-row tw-flex-col md:tw-justify-between tw-items-start md:tw-p-5 tw-p-3">
      <p className="md:tw-pl-2 tw-pl-0 tw-text-md tw-pb-2">{title}</p>
      <div className="tw-w-auto tw-flex md:tw-justify-between tw-mr-2">
        <span>{countObj.readCount}/14 documents read </span>
      </div>
    </div>
  );

  const FileContainer = ({ title, read = false, readTimestamp = "" }) => (
    <div className="tw-bg-gray-50 tw-flex tw-flex-col tw-content-center tw-text-center tw-p-2 tw-m-4 tw-h-40 tw-min-h-fit tw-w-52 tw-border-2 tw-items-center">
      <p className="tw-mb-1">{title}</p>
      <div
        className="tw-w-full tw-h-full tw-flex"
        style={{ alignItems: "end" }}
      >
        <div className="tw-flex-1 tw-flex-col tw-py-2">
          {read ? (
            <div className="tooltip">
              <DoneIcon />
              <div className="tooltiptext">
                Read {formatTimestamp(readTimestamp)}
              </div>
            </div>
          ) : (
            <div className="tooltip">
              <TodoIcon />
            </div>
          )}
          <p className=""></p>
          <p className="tw-pt-2">Read</p>
        </div>
      </div>
    </div>
  );

  const NonReadingItemComp = (candidate, cond, typecode, filename) => (
    <div className="tw-bg-gray-50 tw-flex tw-flex-col tw-content-center tw-text-center tw-p-2 tw-m-4 tw-h-40 tw-min-h-fit tw-w-52 tw-border-2 tw-items-center">
      <p className="tw-mb-1 tw-text-center tw-h-20">{filename}</p>
      <div
        className="tw-w-full tw-h-full tw-flex"
        style={{ alignItems: "center" }}
      >
        <div className="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-content-center">
          {cond ? (
            <div className="tooltip">
              <button
                onClick={async () => {
                  handleDownloadReadingList(
                    candidate,
                    typecode,
                    filename,
                    "application/pdf",
                    "pdf"
                  );
                }}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "14px",
                  width: "80%",
                  backgroundColor: "white",
                  padding: "8px",
                  borderRadius: "5px",
                  border: "1px solid #2196f3"
                }}
              >
                {typecode === "MLSF" && (
                  <div className="tooltiptext">
                    Signed {formatTimestamp(cond)}
                  </div>
                )}
                {loadingTypeCode === typecode ? <LoadingSpinner /> : "Download"}
              </button>
            </div>
          ) : (
            <div className="tooltip tw-flex tw-flex-col tw-pt-3">
              <TodoIcon />
              <p className=""></p>
              <p className="tw-pt-2">Read</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const populateDropRow = candidate => {
    const values = DOCS;
    if (!values) return undefined;

    const output = values.map((row, i) => {
      const { id, title } = row;
      const read =
        candidate &&
        candidate.documents &&
        candidate.documents.readings &&
        candidate.documents.readings[id]; // current person, current line (docs) and current doc - if present they have read the document

      return (
        <FileContainer
          key={i}
          docName={id}
          title={title}
          read={read}
          readTimestamp={read}
          candidateRef={candidate.candidateRef}
          candidate={candidate}
        />
      );
    });

    const hasNET2 =
      candidate &&
      candidate.documents &&
      candidate.documents.readings &&
      candidate.documents.readings["net2_communication_brief_v3.pdf"];

    const hasMLSF =
      candidate &&
      candidate.documents &&
      candidate.documents.readings &&
      candidate.documents.readings["management_of_locker_sign_off.pdf"];

    const hasNonReadingDocs = candidate && candidate.nonReadingListDocs;

    const hasYREG = hasNonReadingDocs && candidate.nonReadingListDocs.YREG;

    const hasYRG4 = hasNonReadingDocs && candidate.nonReadingListDocs.YRG4;

    const hasYRG5 = hasNonReadingDocs && candidate.nonReadingListDocs.YRG5;

    const hasYRG6 = hasNonReadingDocs && candidate.nonReadingListDocs.YRG6;

    const hasYRG7 = hasNonReadingDocs && candidate.nonReadingListDocs.YRG7;

    output.unshift(
      NonReadingItemComp(candidate, hasMLSF, "MLSF", `Management of Lockers`)
    );
    output.unshift(
      NonReadingItemComp(
        candidate,
        hasNET2,
        "NET2",
        `Net 2 Swipe Card Procedure`
      )
    );
    output.unshift(
      NonReadingItemComp(candidate, hasYREG, "YREG", `Medical Questionnaire`)
    );
    output.unshift(
      NonReadingItemComp(
        candidate,
        hasYRG4,
        "YRG4",
        `Numeracy and Literacy Test`
      )
    );

    output.unshift(
      NonReadingItemComp(candidate, hasYRG7, "YRG7", `12 Week Agency Review`)
    );

    output.unshift(
      NonReadingItemComp(candidate, hasYRG6, "YRG6", `6 Week Agency Review`)
    );

    output.unshift(
      NonReadingItemComp(candidate, hasYRG5, "YRG5", `1 Week Agency Review`)
    );

    return output;
  };

  const Spinner = () => (
    // not the same as the spinner in bookings
    <svg
      width="31"
      height="31"
      style={{ marginLeft: "32px" }}
      viewBox="0 0 38 38"
      stroke="#5e7fcc"
    >
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)" strokeWidth="2">
          <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg>
  );

  const populateRTWDocs = c => {
    const NRG1 = c && c.nonReadingListDocs && c.nonReadingListDocs.NRG1;
    if (NRG1) {
      return Object.keys(NRG1)
        .sort((a, b) => b.localeCompare(a))
        .map((el, i) => (
          <div
            key={i}
            className="tw-bg-gray-50 tw-flex tw-flex-col tw-content-center tw-text-center tw-p-2 tw-m-4 tw-h-40 tw-min-h-fit tw-w-52 tw-border-2 tw-items-center"
          >
            <p className="tw-mb-1">
              Return To Work ({moment(el).format("DD/MM/YYYY")})
            </p>
            <div
              className="tw-w-full tw-h-full tw-flex"
              style={{ alignItems: "center" }}
            >
              <div className="tw-flex-1 tw-flex-col tw-py-2">
                <div className="tw-flex tw-justify-center tw-cursor-pointer">
                  {loadingEl === el ? (
                    <LoadingSpinner />
                  ) : (
                    <button
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "14px",
                        width: "80%",
                        backgroundColor: "white",
                        padding: "8px",
                        borderRadius: "5px",
                        border: "1px solid #2196f3"
                      }}
                      onClick={() =>
                        handleDownloadReadingList(
                          c,
                          "YRG1",
                          "Regatta Return To Work",
                          "application/pdf",
                          "pdf",
                          el
                        )
                      }
                    >
                      Download
                    </button>
                  )}
                </div>
              </div>
              <div className="tw-flex-1 tw-flex-col tw-py-2">
                {loadingRtw === el ? (
                  <Spinner />
                ) : agreedTo[el] || NRG1[el].approverEmail ? (
                  <div className="tooltip">
                    <input
                      checked={agreedTo[el] || NRG1[el].approverEmail}
                      disabled={agreedTo[el] || NRG1[el].approverEmail}
                      type={"checkbox"}
                      className="tw-w-6 tw-h-6 tw-my-1 cursor-pointer"
                      onClick={async () => {
                        setLoading(el);
                        handleAgreeToWork(c.candidateRef, el);
                      }}
                    />
                    <div
                      className="tooltiptext"
                      style={{
                        textAlign: "left",
                        paddingLeft: "7",
                        paddingRight: "3",
                        width: "auto"
                      }}
                    >
                      Signed by{" "}
                      {(agreedTo[el] && agreedTo[el].approverEmail) ||
                        NRG1[el].approverEmail}{" "}
                      <br />
                      {(agreedTo[el] &&
                        formatTimestamp(agreedTo[el].acceptedDate)) ||
                        formatTimestamp(NRG1[el].acceptedDate)}
                    </div>
                  </div>
                ) : (
                  <input
                    type={"checkbox"}
                    className="tw-w-6 tw-h-6 tw-my-1 cursor-pointer"
                    onClick={async () => {
                      setLoading(el);
                      handleAgreeToWork(c.candidateRef, el);
                    }}
                  />
                )}
                <p className=""></p>
                <p className="tw-pt-2">Sign Off</p>
              </div>
            </div>
          </div>
        ));
    }
    return <div>NO RTW DOCS</div>;
  };

  return (
    <div>
      <div className="tw-rounded-md tw-overflow-x-auto ">
        <div className="tw-align-middle tw-rounded-md tw-inline-block tw-min-w-full">
          <div className="tw-shadow tw-rounded-md tw-overflow-hidden tw-border-b tw-border-gray-200 ">
            <table className="tw-overflow-x tw-border-collapse tw-min-w-full tw-border-2 tw-border-gray-500 tw-rounded-md tw-mb-8 tw-divide-y tw-divide-gray-200">
              <thead className="tw-border-collapse tw-bg-gray-50 tw-rounded-md tw-border-0 tw-border-gray-500 ">
                <tr>
                  <th
                    scope="tw-col"
                    style={{ width: "25%" }}
                    className="tw-py-4 tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-left tw-text-md tw-font-medium tw-text-gray-500 tw-text-center tw-tracking-wider"
                  >
                    Worker
                  </th>
                  <th
                    scope="col"
                    style={{ width: "40%" }}
                    className="tw-w-full tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-md tw-font-medium tw-text-gray-500 tw-text-center"
                  >
                    Documents
                  </th>
                  <th
                    scope="col"
                    style={{ width: "35%" }}
                    className="tw-w-full tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-md tw-font-medium tw-text-gray-500 tw-text-center"
                  >
                    Return To Work
                  </th>
                </tr>
              </thead>
              <tbody className="tw-bg-white tw-divide-y tw-divide-gray-200">
                {candidates.map((c, i) => (
                  <Fragment key={i}>
                    <tr className="reading-list__rows" key={i * 100}>
                      <td className="tw-text-sm">
                        <div className="tw-flex lg:tw-flex-row tw-flex-col tw-w-full lg:tw-items-center md:tw-text-left tw-text-center">
                          <div style={{ padding: "5px" }}>
                            {hasMedicalIssue(c) ? (
                              <MedicalIcon />
                            ) : (
                              <p style={{ padding: "11px" }} />
                            )}
                          </div>
                          {images && images[c.candidateRef] ? (
                            <CandImage
                              handleOverlay={handleOverlay}
                              passImage={passImage}
                              image={images[c.candidateRef]}
                              firstName={c.firstName}
                            />
                          ) : (
                            <Initials
                              firstName={c.firstName}
                              lastName={c.lastName}
                            />
                          )}
                          <p className="tw-font-bold tw-font-lg lg:tw-pl-0 tw-pl-1">
                            {c.firstName} {c.lastName}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div
                          className={`tw-flex tw-min-h-full tw-justify-center`}
                        >
                          <ViewButton
                            id={`${i}${c.lastName}L1`}
                            fn={() => {
                              setHighligtning(`${i}${c.lastName}L1`);
                              setDisplay("Documents");
                              if (display === "Documents" && selected === i) {
                                setSelected(null);
                                setDisplay("");
                              } else {
                                setSelected(i);
                              }
                            }}
                            num="L1"
                          />
                        </div>
                      </td>
                      <td>
                        <div
                          className={`tw-flex tw-min-h-full tw-justify-center`}
                        >
                          <ViewButton
                            disabled={
                              !(
                                c &&
                                c.nonReadingListDocs &&
                                c.nonReadingListDocs.NRG1
                              )
                            }
                            id={`${i}${c.lastName}RTW`}
                            fn={() => {
                              setHighligtning(`${i}${c.lastName}RTW`);
                              setDisplay("RTW");
                              if (display === "RTW" && selected === i) {
                                setSelected(null);
                                setDisplay("");
                              } else {
                                setSelected(i);
                              }
                            }}
                            num="RTW"
                          />
                        </div>
                      </td>
                    </tr>

                    {selected === i ? (
                      <tr>
                        <td colSpan="6">
                          {display === "RTW" ? (
                            <></>
                          ) : (
                            <Header
                              title={`Documents - ${c.firstName} ${c.lastName}`}
                              countObj={getDocCount(c)} // individual candidate
                            />
                          )}
                          <div className="tw-flex tw-min-w-full tw-overflow-y-auto tw-flex-wrap tw-pb-4 tw-px-0 tw-justify-center tw-items-center">
                            {display === "RTW"
                              ? populateRTWDocs(c)
                              : populateDropRow(c)}
                          </div>
                        </td>
                      </tr>
                    ) : null}
                  </Fragment>
                ))}
              </tbody>
            </table>
            <a className="d-none" ref={downloadRef}></a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegattaDocumnents;
